import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { Platform } from "@/components/Platform";
import { Modules } from "@/components/Modules";
import { CoverageBand } from "@/components/CoverageBand";
import { Transparency } from "@/components/Transparency";
import { FounderContact } from "@/components/FounderContact";
import { Footer } from "@/components/Footer";

const Home = () => {
  return (
    <div
      data-testid="equitygrove-home"
      className="bg-grove-ground text-grove-ink antialiased min-h-screen overflow-x-hidden font-body selection:bg-grove-deep selection:text-emerald-50"
    >
      <Navbar />
      <Hero />
      <Marquee />
      <Platform />
      <Modules />
      <CoverageBand />
      <Transparency />
      <FounderContact />
      <Footer />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
